import React from "react";
import Navbar from "./Navbar"
import Search from "./Search"
import Chats from "./Chats"

const Sidebar = ({settoggle}) => {
  return (

    // this is the sidebar of the chat 
    <div className="sidebar">
      <Navbar />
      <Search/>
      <Chats settoggle = {settoggle}/>
    </div>
  );
};

export default Sidebar;
